import {
  Create,
  SimpleForm,
  ReferenceInput,
  SelectInput,
  AutocompleteArrayInput,
  useNotify,
  useRedirect,
} from "react-admin";
import { useEffect, useState } from "react";
import { apiUrl } from "../../apiendpoint";

export const UserGroupCreate = () => {
  const notify = useNotify();
  const redirect = useRedirect();
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem("access_token");

    if (!token) {
      notify("Not authenticated", { type: "warning" });
      return;
    }

    fetch(`${apiUrl}users`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch users");
        return res.json();
      })
      .then((data) => {
        setUsers(
          data.map((u) => ({
            id: u.id,
            name: u.name || u.email,
          }))
        );
      })
      .catch((err) => {
        console.error(err);
        notify("Failed to load users", { type: "error" });
      });
  }, [notify]);

  return (
    <Create
      title="Assign Users to Group"
      mutationMode="pessimistic"
      transform={(data) => ({
        ...data,
        user_ids: data.user_ids || [],
      })}
      mutationOptions={{
        // ✅ Fixed onSuccess to correctly receive the response
        onSuccess: (response) => {
          notify("Users assigned to group successfully 🎉", { type: "success" });
          redirect("/usergroups");
          console.log("Mutation response:", response);
        },
        onError: (error) => {
          console.error("ERROR:", error);
          notify("Error assigning users to group ❌", { type: "error" });
        },
      }}
    >
      <SimpleForm>
        {/* Select Group */}
        <ReferenceInput source="group_id" reference="groups" label="Group">
          <SelectInput optionText="name" />
        </ReferenceInput>

        {/* Users */}
        <AutocompleteArrayInput
          source="user_ids"
          label="Users"
          choices={users}
          optionText="name"
          optionValue="id"
          fullWidth
        />
      </SimpleForm>
    </Create>
  );
};